import { BILLING_STRINGS } from './constants/billing-strings';

const COPY = BILLING_STRINGS.PURCHASE;

/** The term fields a one-time plan or its quote carries (FR-127). */
export interface AccessTerm {
  accessTermDays: number | null;
  accessTermMonths: number | null;
}

/**
 * A one-time plan's access term in its own unit: "7 days", "12 months",
 * "1 day". Days win only because the Backend guarantees at most one term is
 * set; this is not a precedence rule.
 *
 * @param term - the plan's or quote's term fields
 * @returns the readable term, or null when the plan carries none
 */
export function formatAccessTerm(term: AccessTerm): string | null {
  if (term.accessTermDays) {
    return term.accessTermDays === 1
      ? COPY.TERM_DAYS_ONE
      : COPY.TERM_DAYS.replace('{count}', String(term.accessTermDays));
  }
  if (term.accessTermMonths) {
    return term.accessTermMonths === 1
      ? COPY.TERM_MONTHS_ONE
      : COPY.TERM_MONTHS.replace('{count}', String(term.accessTermMonths));
  }
  return null;
}
